import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import access from '../../../../utils/access'

import style from '../../style'

import Container from '../../partials/Container'
import UserEditor from '../../partials/UserEditor'
import CommunityTable from '../../partials/CommunityTable'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('User', 'Auth', 'Community', 'Config')
@observer
export class EditUser extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: null,
        inputs: {}
      }
    }
  }

  componentWillMount () {
    const _findUserLoop = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findUserLoop()
        }

        Promise.all([
          this.props.Community.getUserCommunities(
            this.props.match.params.userId
          ),
          this.props.User.getUser(this.props.match.params.userId)
        ])
          .catch(() => this.props.history.push(`/dashboard/user`))
          .then(
            () =>
              access.adminGroups(this.props.User.me.permissions)
                ? this.props.User.getAllGroups()
                : null
          )
      }, 100)
    }

    _findUserLoop()
  }

  onInputChange (field, e) {
    // console.log(e.target.name, e.target.value)
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        inputs: {
          ...this.state.editor.inputs,
          [e.target.name]: e.target.value
        }
      }
    })
  }

  onFormSubmit (group, e) {
    e.preventDefault()

    Promise.all(
      Object.keys(this.state.editor.inputs).map(key => {
        const args = {
          userId: this.props.match.params.userId,
          value: this.state.editor.inputs[key]
        }

        return this.props.User.patchUser(args.userId, key, args.value)
      })
    )
      .then(res => {
        this.setState({
          ...this.state,
          editor: {
            inputs: {},
            active: false,
            field: null
          }
        })
      })
      .catch(e => {
        console.warn(e)
      })
  }

  onTRClick (name, e) {
    const user =
      this.props.Auth.token.userId === this.props.match.params.userId
        ? this.props.User.me
        : this.props.User.all
            .slice()
            .find(u => u.id === this.props.match.params.userId)

    if (!user) {
      return
    }

    const _inputs = {}
    if (name === 'fullName') {
      _inputs.firstName = user.firstName
      _inputs.lastName = user.lastName
    } else {
      _inputs[name] = user[name] || ''
    }

    e.preventDefault()
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        inputs: _inputs,
        active: !this.state.editor.active,
        field: name
      }
    })
  }

  onGroupClick (e) {
    const gId = e.currentTarget.dataset.gid
    const _group = this.props.User.groups.slice().find(g => g.id === gId)

    const user =
      this.props.Auth.token.userId === this.props.match.params.userId
        ? this.props.User.me
        : this.props.User.all
            .slice()
            .find(u => u.id === this.props.match.params.userId)

    const _userGroupIndex = user.groups.findIndex(g => g.id === gId)

    if (!_group) {
      return
    }

    return this.props.User.patchUser(user.id, 'group', [
      ...(_userGroupIndex > -1
        ? [
          ...user.groups
              .slice(0, _userGroupIndex)
              .reduce((arr, g) => [...arr, g.id], []),
          ...user.groups
              .slice(_userGroupIndex + 1)
              .reduce((arr, g) => [...arr, g.id], [])
        ]
        : [...user.groups.slice().reduce((arr, g) => [...arr, g.id], []), gId])
    ])
  }

  onSaveClick (e) {
    // xhr post

    const url = Object.keys(this.props.match.params).reduce(
      (_url, key) =>
        key !== 'userId'
          ? _url.replace(`:${key}`, this.props.match.params[key])
          : _url,
      this.props.match.path.replace(`/:userId`, ``)
    )

    return this.props.history.push(url)
  }

  render () {
    const communities = Array.prototype.concat
      .apply(
        [],
        Object.keys(this.props.Community.groups).map(
          comId => this.props.Community.groups[comId]
        )
      )
      .reduce((arr, g) => {
        if (g.users.includes(this.props.match.params.userId)) {
          if (!arr.find(c => c.id === g.comId)) {
            arr.push(
              this.props.Community.all.slice().find(c => c.id === g.comId)
            )
          }
        }

        return arr
      }, [])

    const user =
      this.props.Auth.token.userId === this.props.match.params.userId
        ? this.props.User.me
        : this.props.User.all
            .slice()
            .find(u => u.id === this.props.match.params.userId)

    return (
      <Container
        {...this.props}
        hide={!access.adminGroups(this.props.User.me.permissions || {})}
      >
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(style.headers.h2)}>Edit Member</h2>
          </Col>
          <Col>
            <Row>
              <Col />
              <Col>
                <span
                  onClick={this.onSaveClick.bind(this)}
                  className={css(style.buttons.button, style.buttons.red)}
                >
                  Save
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <UserEditor
            theme={THEME_LIST[this.props.Config.theme]}
            user={user}
            me={this.props.User.me || {}}
            groups={this.props.User.groups.slice()}
            onGroupClick={this.onGroupClick.bind(this)}
            editor={this.state.editor}
            onTRClick={this.onTRClick.bind(this)}
            onInputChange={this.onInputChange.bind(this)}
            onFormSubmit={this.onFormSubmit.bind(this)}
          />
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <h4 className={css(style.headers.h4)}>
                  Communities ({communities.length})
                </h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <CommunityTable
                  theme={THEME_LIST[this.props.Config.theme]}
                  communities={communities}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default EditUser



// WEBPACK FOOTER //
// ./src/components/User/User/Edit/index.js